<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="sc-dhKdcB iLnXPO">
    <path
      d="m18.282 10.616-3.474 3.474-2.178-1.746 4.68-4.68-.972-.972-4.68 4.68-1.746-2.178 3.474-3.474-.972-.99-4.338 4.356L4.8 17.744a1.124 1.124 0 0 0-.036.63c.048.216.15.402.306.558.228.228.498.342.81.342.096 0 .228-.024.396-.072l8.64-3.258 4.356-4.356-.99-.972Zm-9.216-.27 1.998 2.484 2.592 2.106-4.626 1.746-1.71-1.71 1.746-4.626ZM6.78 16.394l.828.828-1.332.504.504-1.332Z"
      fill="#000"
    ></path>
  </svg>
</template>
